define.alias("shared/models/tiktok-post", "calendar/models/tiktok-post");